function initialState() {
  return {
    countries: [],
  };
}

let state = initialState();

export { initialState, state };
